// extracted by mini-css-extract-plugin
export default {"flex":"MoveDivision_flex__XfF8K","title":"MoveDivision_title__RXG4m","input_text":"MoveDivision_input_text__Pt1X7"};